<script setup lang="ts">
type StudentUserData = App.Auth.Data.StudentUserData;

import Alert from '@/components/alert/Alert.vue';
import DangerDialog from '@/components/dialog/DangerDialog.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import FormRows from '@/components/formRows/FormRows.vue';
import FormTextInput from '@/components/formTextInput/FormTextInput.vue';

import Check from '@/icons/line/check.svg';
import ExclamationCircle from '@/icons/line/exclamation-circle.svg';

const props = defineProps<{
  user: StudentUserData;
}>();

const { show, closeLocally } = useDialog();
const [isCancelDialogOpen, toggleCancelDialog] = useToggle(false);

const isDialogOpen = computed(() => !isCancelDialogOpen.value && show.value);

const form = useForm({
  url: route('student.profile.email.update'),
  method: 'PUT',
  fields: {
    email: props.user.email
  }
});

function handleFormSubmit() {
  form.submit();
}

function handleToggleCancelDialog() {
  if (form.isDirty) {
    toggleCancelDialog();
    return;
  }
  closeLocally();
}

function handleCancelDialogConfirm() {
  toggleCancelDialog();
  closeLocally();
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    title="Email"
    :cancelButtonDisabled="!form.isDirty"
    :confirmButtonIcon="Check"
    :isLoading="form.processing"
    :isOpen="isDialogOpen"
    confirmButtonLabel="Save changes"
    cancelButtonLabel="Reset"
    @onCancel="form.reset"
    @onClose="handleToggleCancelDialog"
    @onConfirm="handleFormSubmit"
  >
    <template #form>
      <FormRows>
        <Alert
          v-if="user.email_verifications?.length"
          :icon="ExclamationCircle"
          color="warning"
          title="Email address update pending"
          variant="soft"
          hideClose
        >
          <div class="flex flex-col gap-y-0.5">
            <p>
              We emailed a verification link to
              <strong>{{ user.email_verifications[0].new_email }}</strong
              >. Click it to confirm your new address.
            </p>
            <p>If you haven’t received the email, enter your new email address below.</p>
          </div>
        </Alert>
        <FormTextInput
          :error="form.errors.email"
          :modelValue="form.fields.email"
          isOptional
          label="Email"
          name="email"
          type="email"
          @update:modelValue="(value) => (form.fields.email = value)"
        />
      </FormRows>
    </template>
  </Dialog>
  <DangerDialog
    title="Discard Changes?"
    message="Your changes will not be saved."
    :isOpen="isCancelDialogOpen"
    cancelButtonLabel="Stay on this page"
    confirmButtonLabel="Discard changes"
    isStacked
    @onCancel="toggleCancelDialog"
    @onClose="toggleCancelDialog"
    @onConfirm="handleCancelDialogConfirm"
  />
</template>
